module.exports = __webpack_public_path__ + "icon_fecha_encuestas.png";